// Device capability detection for progressive rendering.
// All checks are best-effort — absent APIs are treated as low capability.

/**
 * Returns true on devices that appear to have sufficient GPU/memory budget
 * to enable shadow maps without degrading frame rate.
 *
 * Heuristic: deviceMemory >= 4 GB OR hardwareConcurrency >= 6 cores.
 * Both APIs are advisory and may be absent (treated as 0).
 */
export function isHighEndDevice(): boolean {
  const mem = (navigator as Navigator & { deviceMemory?: number }).deviceMemory ?? 0;
  const cores = navigator.hardwareConcurrency ?? 0;
  return mem >= 4 || cores >= 6;
}
